<template>
  <div class="compare-data">
    <div class="title">{{ title }}</div>
    <el-table :data="salescompareData" border stripe>
      <el-table-column prop="shop_name" label="店铺" />
      <el-table-column label="目标">
        <template slot-scope="scope">
          <span><span v-if="type == 'price'">￥</span>{{ scope.row.target[name] || 0 }}</span>
        </template>
      </el-table-column>
      <el-table-column label="已核算">
        <template slot-scope="scope">
          <span><span v-if="type == 'price'">￥</span>{{ scope.row.total | total(count, type) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="完成率">
        <template slot-scope="scope">
          <!-- <el-progress :percentage="scope.row.target[name] | rate(scope.row.total,count,name)"></el-progress>  -->
          <div class="my-progress">
            <div
              v-rate
              class="my-progress-active"
              :progress="
                scope.row.target[name] | rate(scope.row.total, count, name)
              "
            />
          </div>
          <span
            v-content
            :progress="
              scope.row.target[name] | rate(scope.row.total, count, name)
            "
          />
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: 'CompareData',
  directives: {
    rate: {
      inserted: function(el) {
        const progress = el.getAttribute('progress')
        el.style.width = progress + '%'
      },
      update: function(el) {
        const progress = el.getAttribute('progress')
        el.style.width = progress + '%'
      }
    },
    content: {
      inserted: function(el) {
        const progress = el.getAttribute('progress')
        el.innerText = progress + '%'
      },
      update: function(el) {
        const progress = el.getAttribute('progress')
        el.innerText = progress + '%'
      }
    }
  },
  filters: {
    total(total, val2, type) {
      let value = 0
      for (const key in total) {
        if (val2.indexOf(key) > -1) {
          value += Number(total[key])
        }
      }
      if (type == 'price') {
        return value / 100
      } else {
        return value
      }
    },
    rate(target, total, val2, name) {
      if (target && total) {
        let value = 0
        for (const key in total) {
          if (val2.indexOf(key) > -1) {
            value += Number(total[key])
          }
        }
        if (
          name == 'total_price' ||
          name == 'renew_price' ||
          name == 'new_sign_price'
        ) {
          value = value / 100
        }
        const rate = parseInt((value / target) * 100)
        // return rate = rate > 100 ? 100 : rate;
        return rate
      } else {
        return 100
      }
    }
  },
  props: {
    salescompareData: Array,
    title: String,
    type: String,
    name: String,
    count: Array
  },
  data() {
    return {
      shopData: []
    }
  },
  mounted() {},
  methods: {}
}
</script>
<style lang="scss" scoped>
.compare-data {
  margin-bottom: 50px;
  width: 760px;
}
.my-progress {
  width: 120px;
  height: 6px;
  background-color: #ebeef5;
  overflow: hidden;
  position: relative;
  vertical-align: middle;
  border-radius: 100px;
  margin: 0 auto;
  .my-progress-active {
    height: 100%;
    background-color: $color_blue;
    position: absolute;
    left: 0;
    top: 0;
  }
}
</style>
